import React from "react";
import {connect} from "react-redux";
import locale from "../../locale";

class LayoutHeader extends React.Component
{
	getAnchorElement(link)
	{
		const anchorName = link.getAttribute('href');
		if (anchorName[0] !== '#') {
			return null;
		}

		try {
			return document.querySelector(anchorName);
		} catch (e) {
		}
	}

	applyPageScrollingMenu()
	{
		const onScrollPage = () => {
			const headerHeight = document.querySelector('header').offsetHeight;
			const fromTop = window.scrollY + headerHeight;

			const links = document.querySelectorAll('.landing-nav-links a');
			for (let i = 0; i < links.length; i++) {
				let link = links[i];

				const section = this.getAnchorElement(link);
				if (!section) {
					continue;
				}

				const sectionTop = section.offsetTop;
				const sectionBottom = sectionTop + section.offsetHeight;
				if (sectionTop <= fromTop && sectionBottom > fromTop) {
					link.classList.add('landing-nav-link-current');
				} else {
					link.classList.remove('landing-nav-link-current');
				}
			}
		};

		window.addEventListener('scroll', onScrollPage, false);

		onScrollPage();
	}

	onMenuItemClick(e)
	{
		e.preventDefault();

		const anchor = this.getAnchorElement(e.target);
		if (!anchor) {
			return;
		}

		const headerHeight = document.querySelector('header').offsetHeight;
		window.scroll(0, anchor.offsetTop - headerHeight);
	}

	componentDidMount()
	{
		setTimeout(() => this.applyPageScrollingMenu(), 100);
	}

	render()
	{
		const {event, eventSettings, watchKey, registered} = this.props;

		let logoUrl = '';
		let logoHref = `/watch/${watchKey}`;

		if (event.modulePage.banner && event.modulePage.banner[0]) {
			logoUrl = event.modulePage.banner[0].url;
			if (event.modulePage.banner[0].href) {
				logoHref = event.modulePage.banner[0].href;
			}
		}

		const playerSettings = eventSettings.find((options) => options.name === 'player') || {};

		const menuItems = [{
			href: '#player',
			title: locale.getProperty(playerSettings, 'menuTitle')
				|| locale.getProperty(playerSettings, 'title')
				|| locale.get('header-nav-player'),
		}];

		eventSettings.forEach((options) => {
			if (['main', 'header', 'player', 'footer'].indexOf(options.name) >= 0) {
				return;
			}
			if (options.hasOwnProperty('showInMenu') && !options.showInMenu) {
				return;
			}

			if (options.showAfterRegistration && !registered) {
				return;
			}
			if (options.hasOwnProperty('enabled') && !options.enabled) {
				return;
			}

			menuItems.push({
				href: `#${options.name}`,
				title: locale.getProperty(options, 'menuTitle')
					|| locale.getProperty(options, 'title')
					|| locale.get(`header-nav-${options.name}`),
			});
		});

		return (
			<header>
				<div className="header-wrapper">
					<section className="landing-logo">
						{logoUrl ?
							<a href={logoHref}>
								<img src={logoUrl} alt="logo" className="landing-logo-image"/>
							</a>
						: null}
					</section>

					<section className="landing-nav-links">
						{menuItems.length > 1 ? menuItems.map(({href, title}, index) =>
							<a key={`menu_item_${index}`} href={href} onClick={this.onMenuItemClick.bind(this)}>
								{title}
							</a>
						) : null}
					</section>
				</div>
			</header>
		);
	}
}

const mapStateToProps = (store) => ({
	watchKey: store.watchKey,
	event: store.event,
	registered: store.registered,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutHeader);
